import { ArrowRight, BookOpen } from 'lucide-react-native';
import { Pressable, StyleSheet, View } from 'react-native';

import { Overline } from '@/components/Overline';
import { Text } from '@/components/Text';
import { colors, radii, spacing } from '@/constants/theme';

export type WhileYouWaitCardProps = {
  onPress: () => void;
  testID?: string;
};

/** "While you wait: Review the content playbook" (Figma "Order 4" and "Track"). */
export function WhileYouWaitCard({ onPress, testID }: WhileYouWaitCardProps) {
  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel="While you wait, review the content playbook"
      style={({ pressed }) => [styles.card, pressed && styles.pressed]}
      testID={testID}
    >
      <View style={styles.icon}>
        <BookOpen size={22} color={colors.deepGreen} strokeWidth={2} />
      </View>
      <View style={styles.text}>
        <Overline>While you wait</Overline>
        <Text variant="bodyBold" color="deepGreen">
          Review the content playbook
        </Text>
      </View>
      <View style={styles.arrow}>
        <ArrowRight size={16} color={colors.frost} strokeWidth={2.5} />
      </View>
    </Pressable>
  );
}

const ICON_TILE = 48;
const ARROW = 28;

const styles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.md,
    padding: spacing.base,
    borderRadius: radii.lg,
    backgroundColor: colors.brightGreenSoft,
  },
  pressed: { opacity: 0.7 },
  icon: {
    width: ICON_TILE,
    height: ICON_TILE,
    borderRadius: radii.base,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.surface,
  },
  text: { flex: 1, gap: 2 },
  arrow: {
    width: ARROW,
    height: ARROW,
    borderRadius: radii.full,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.deepGreen,
  },
});
